import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, A11y } from "swiper/modules";

import {
  FaGoogle,
  FaStar,
  FaQuoteLeft,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

import "./Review.css";

import "swiper/css";
import "swiper/css/navigation";

export default function Review() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const reviews = [
  {
    name: "Amit Verma",
    date: "18/09/2026",
    rating: 5,
    review:
      "Excellent sofa repair service. The team was professional and completed the work neatly.",
  },
  {
    name: "Pooja Sharma",
    date: "12/09/2026",
    rating: 5,
    review:
      "Very good service. Sofa fabric was changed beautifully and the finishing was excellent.",
  },
  {
    name: "Rohit Kumar",
    date: "08/09/2026",
    rating: 5,
    review:
      "Great work and reasonable pricing. My old sofa looks completely new now.",
  },
  {
    name: "Neha Gupta",
    date: "02/09/2026",
    rating: 5,
    review:
      "Very polite staff and excellent workmanship. Sofa repair was done at my home on time.",
  },
  {
    name: "Sanjay Singh",
    date: "27/08/2026",
    rating: 4,
    review:
      "Good quality sofa repair service. The team was helpful and professional throughout.",
  },
  {
    name: "Ayesha Khan",
    date: "21/08/2026",
    rating: 5,
    review:
      "Really happy with the sofa restoration. The finishing and fabric quality were very good.",
  },
];

  return (
    <section className="reviews-section">

      <div className="reviews-container">

        {/* ================= HEADER ================= */}

        <div className="reviews-heading">

          <span className="reviews-subtitle">
            CUSTOMER REVIEWS
          </span>

          <h2>
            What Our <span>Customers Say</span>
          </h2>

          <p>
            Trusted by hundreds of customers for quality sofa repair,
            reupholstery and restoration services.
          </p>

        </div>


        {/* ================= RATING PANEL ================= */}

        <div className="rating-panel">

          <div className="rating-top">

            <div className="google-logo">
              <FaGoogle />
            </div>

            <div className="rating-google-text">
              <span>TRUSTED ON</span>
              <strong>Google</strong>
            </div>

          </div>


          <div className="rating-score">
            <strong>4.9</strong>
            <span>/5</span>
          </div>


          <div className="rating-stars">

            {[1, 2, 3, 4, 5].map((star) => (
              <FaStar key={star} />
            ))}

          </div>


          <p className="rating-description">
            Excellent customer satisfaction
          </p>


          <div className="rating-divider"></div>


          <div className="rating-stat">
            <strong>289+</strong>
            <span>Customer Reviews</span>
          </div>


          <a
            href="https://share.google/ZJUL0OdmdW6XjNeFf"
            target="_blank"
            rel="noopener noreferrer"
            className="google-review-btn"
          >
            <FaGoogle />
            View Reviews
          </a>

        </div>


        {/* ================= SLIDER ================= */}

        <div className="reviews-slider-area">

          <Swiper
            modules={[Navigation, Autoplay, A11y]}
            spaceBetween={22}
            slidesPerView={1}
            loop={true}

            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}

            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}

            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}

            breakpoints={{
              576: {
                slidesPerView: 1,
                spaceBetween: 18,
              },

              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },

              1100: {
                slidesPerView: 3,
                spaceBetween: 22,
              },
            }}
          >

            {reviews.map((review, index) => (

              <SwiperSlide key={index}>

                <div className="review-card">

                  {/* Quote */}

                  <div className="review-quote">
                    <FaQuoteLeft />
                  </div>


                  {/* User */}

                  <div className="review-card-header">

                    <div className="review-avatar">
                      {review.name.charAt(0)}
                    </div>

                    <div className="review-user">

                      <h4>{review.name}</h4>

                      <span>{review.date}</span>

                    </div>

                    <div className="google-small">
                      <FaGoogle />
                    </div>

                  </div>


                  {/* Stars */}

                  <div className="review-stars">

                    {[1, 2, 3, 4, 5].map((star) => (

                      <FaStar
                        key={star}
                        className={
                          star <= review.rating
                            ? "active-star"
                            : "inactive-star"
                        }
                      />

                    ))}

                  </div>


                  {/* Review */}

                  <p className="review-text">
                    "{review.review}"
                  </p>


                  {/* Verified */}

                  <div className="verified-review">

                    <span>✓</span>

                    Verified Review

                  </div>

                </div>

              </SwiperSlide>

            ))}

          </Swiper>


          {/* ================= CONTROLS ================= */}

          <div className="review-controls">

            <button
              ref={prevRef}
              className="review-arrow"
              aria-label="Previous review"
            >
              <FaChevronLeft />
            </button>

            <div className="review-control-line"></div>

            <span>Customer Reviews</span>

            <div className="review-control-line"></div>

            <button
              ref={nextRef}
              className="review-arrow"
              aria-label="Next review"
            >
              <FaChevronRight />
            </button>

          </div>

        </div>

      </div>

    </section>
  );
}